import { render, staticRenderFns } from "./AddEventSubmit.vue?vue&type=template&id=362ba5b4&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddEventSubmit.vue"
export default component.exports